export default __webpack_public_path__ + "app/images/f16096d5525d796cb8ab0d48f026dd73.svg";